import { render, staticRenderFns } from "./DnaReagent.vue?vue&type=template&id=77eb03f8&"
import script from "./DnaReagent.vue?vue&type=script&lang=js&"
export * from "./DnaReagent.vue?vue&type=script&lang=js&"
import style0 from "./DnaReagent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports